const gerar_arquivo_de_migracao_da_situacao_do_aluno = [
  {
    path: "/gerar-arquivo-de-migracao-da-situacao-do-aluno",
    name: "gerar_arquivo_de_migracao_da_situacao_do_aluno",
    meta: {
      breadCrumb: "Censo Escolar - Migração da Situação do Aluno",
      allowedPermissions: ["migracao_situacao_aluno"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoDeMigracaoDaSituacaoDoAluno/GerarArquivoDeMigracaoDaSituacaoDoAluno.vue"
      ),
  },
];

export { gerar_arquivo_de_migracao_da_situacao_do_aluno };
